import React from "react";
import { Typography } from "@mui/material";

function Policy(props) {
  const { policyData } = props;
  return (
    <div className="customerPolicyLayout">
      {policyData &&
        policyData.map((policy, index) => (
          <div>
            {" "}
            {policy.title && policy.body ? (
              <div key={index}>
                <Typography className="marginTopBottom20">
                  {index + 1}. {policy.title}
                </Typography>
                <div>
                  {policy.body.length > 1 ? (
                    policy.body.map((p, idx) => (
                      <div key={idx}>
                        <Typography>
                          {index + 1}.{idx + 1} {p?.subTitle}
                        </Typography>
                        <ul type="disc">
                          <li>{p?.content[0]}</li>
                          <li>{p?.content[1]}</li>
                        </ul>
                      </div>
                    ))
                  ) : (
                    <div key={index}>
                      <Typography>
                        {index + 1}.{index}. {policy.body[0]?.subTitle}
                      </Typography>
                      <ul type="disc">
                        <li>{policy.body[0]?.content[0]}</li>
                        <li>{policy.body[0]?.content[1]}</li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            ) : policy.body && policy.content ? (
              <div key={index}>
                <Typography className="marginTopBottom20">
                  {" "}
                  {policy.body}
                </Typography>
                <div>
                  {policy.content.length > 1 &&
                    policy.content.map((p, idx) => (
                      <div className="marginTop" key={idx}>
                        <Typography>
                          {idx + 1}. {p?.title}
                        </Typography>
                        <Typography>{p?.description}</Typography>
                      </div>
                    ))}
                </div>
              </div>
            ) : (
              <ol type={index} start={index + 1}>
                <li key={index}>
                  <span> {policy.title} : </span>
                  <span>{policy.content}</span>
                </li>
              </ol>
            )}
          </div>
        ))}
    </div>
  );
}

export default Policy;
